import script from "./MatchSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__